import { Injectable, Provider } from '@angular/core';

@Injectable()
export class ClienteResource {
  getProfile(_: any): any {
    return null;
  }

  getAverageDemand(_: any): any {
    return null;
  }

  getAddresses(_: any): any {
    return null;
  }

  getFirstSteps(_: any): any {
    return { $promise: {} };
  }
}

export function ClienteResourceFactory(i: any) {
  return i.get('ClienteResource');
}

export const ClienteResourceProvider: Provider = {
  provide: ClienteResource,
  useFactory: ClienteResourceFactory,
  deps: ['$injector'],
};
